"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorType = exports.ErrorGettingAllOwnedNFTsInfo = exports.ErrorGettingNFTInfo = exports.ErrorGettingCollections = exports.ErrorInvalidArg = exports.ErrorAPIQuery = exports.ErrorInvalidAddress = exports.ErrorInvalidRange = exports.ErrorInvalidPrivateKey = exports.ErrorInvalidSeed = exports.ErrorInvalidMnemnoic = exports.ErrorGeneric = exports.ErrorSDKAuthService = exports.ErrorSDKAuthInitialization = exports.ErrorSDKInitialization = void 0;
var ErrorSDKInitialization = /** @class */ (function (_super) {
    __extends(ErrorSDKInitialization, _super);
    function ErrorSDKInitialization() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorSDKInitialization;
}(Error));
exports.ErrorSDKInitialization = ErrorSDKInitialization;
var ErrorSDKAuthInitialization = /** @class */ (function (_super) {
    __extends(ErrorSDKAuthInitialization, _super);
    function ErrorSDKAuthInitialization() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorSDKAuthInitialization;
}(Error));
exports.ErrorSDKAuthInitialization = ErrorSDKAuthInitialization;
var ErrorSDKAuthService = /** @class */ (function (_super) {
    __extends(ErrorSDKAuthService, _super);
    function ErrorSDKAuthService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorSDKAuthService;
}(Error));
exports.ErrorSDKAuthService = ErrorSDKAuthService;
var ErrorGeneric = /** @class */ (function (_super) {
    __extends(ErrorGeneric, _super);
    function ErrorGeneric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorGeneric;
}(Error));
exports.ErrorGeneric = ErrorGeneric;
var ErrorInvalidMnemnoic = /** @class */ (function (_super) {
    __extends(ErrorInvalidMnemnoic, _super);
    function ErrorInvalidMnemnoic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorInvalidMnemnoic;
}(Error));
exports.ErrorInvalidMnemnoic = ErrorInvalidMnemnoic;
var ErrorInvalidSeed = /** @class */ (function (_super) {
    __extends(ErrorInvalidSeed, _super);
    function ErrorInvalidSeed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorInvalidSeed;
}(Error));
exports.ErrorInvalidSeed = ErrorInvalidSeed;
var ErrorInvalidPrivateKey = /** @class */ (function (_super) {
    __extends(ErrorInvalidPrivateKey, _super);
    function ErrorInvalidPrivateKey() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorInvalidPrivateKey;
}(Error));
exports.ErrorInvalidPrivateKey = ErrorInvalidPrivateKey;
var ErrorInvalidRange = /** @class */ (function (_super) {
    __extends(ErrorInvalidRange, _super);
    function ErrorInvalidRange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorInvalidRange;
}(Error));
exports.ErrorInvalidRange = ErrorInvalidRange;
var ErrorInvalidAddress = /** @class */ (function (_super) {
    __extends(ErrorInvalidAddress, _super);
    function ErrorInvalidAddress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorInvalidAddress;
}(Error));
exports.ErrorInvalidAddress = ErrorInvalidAddress;
var ErrorAPIQuery = /** @class */ (function (_super) {
    __extends(ErrorAPIQuery, _super);
    function ErrorAPIQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorAPIQuery;
}(Error));
exports.ErrorAPIQuery = ErrorAPIQuery;
var ErrorInvalidArg = /** @class */ (function (_super) {
    __extends(ErrorInvalidArg, _super);
    function ErrorInvalidArg() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorInvalidArg;
}(Error));
exports.ErrorInvalidArg = ErrorInvalidArg;
var ErrorGettingCollections = /** @class */ (function (_super) {
    __extends(ErrorGettingCollections, _super);
    function ErrorGettingCollections() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorGettingCollections;
}(Error));
exports.ErrorGettingCollections = ErrorGettingCollections;
var ErrorGettingNFTInfo = /** @class */ (function (_super) {
    __extends(ErrorGettingNFTInfo, _super);
    function ErrorGettingNFTInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorGettingNFTInfo;
}(Error));
exports.ErrorGettingNFTInfo = ErrorGettingNFTInfo;
var ErrorGettingAllOwnedNFTsInfo = /** @class */ (function (_super) {
    __extends(ErrorGettingAllOwnedNFTsInfo, _super);
    function ErrorGettingAllOwnedNFTsInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorGettingAllOwnedNFTsInfo;
}(Error));
exports.ErrorGettingAllOwnedNFTsInfo = ErrorGettingAllOwnedNFTsInfo;
exports.errorType = {
    ErrorSDKInitialization: 'SDK not initialized properly',
    ErrorSDKAuthInitialization: 'initAuth method should be called before connect method',
    ErrorSDKAuthService: 'Please Provide valid Authentication Service',
    ErrorGeneric: 'Something went wrong. Please try again',
};
